// extracted by mini-css-extract-plugin
export default {"featureSection":"FeatureSection_featureSection__niGWo"};